'use strict';

bbw.model.RulesCollection = ngtk.model.List.extend({

    _itemModel: bbw.model.Rules,

    load: function() {
        return this._loadFromApi('get', 'admin/rules').then(function(response) {
            this._setFromApiResult(response.collection);
        }.bind(this));
    }

});